import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { getConfigurationDataKey } from '../utils';
import { ResourceContent } from '.';

export const RequiredFieldsNote: React.FC = () => {
  return (
    <Row>
      <Col>
        <p className='text-required float-end general-note'>
          <ResourceContent contentKey={getConfigurationDataKey('general.required-fields-note')} />
        </p>
      </Col>
    </Row>
  );
};
